import { render, staticRenderFns } from "./SendTopic.vue?vue&type=template&id=37ccb507"
import script from "./SendTopic.vue?vue&type=script&lang=js"
export * from "./SendTopic.vue?vue&type=script&lang=js"
import style0 from "./SendTopic.vue?vue&type=style&index=0&id=37ccb507&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports